import { render } from "./BannerSetting.vue?vue&type=template&id=5874d4f0"
import script from "./BannerSetting.vue?vue&type=script&lang=js"
export * from "./BannerSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__